if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}


// subscription block sticky on scroll

var $sticky = $('.product__info-wrapper .product-form-sticky');
if (!!$sticky.offset()) { // make sure ".sticky" element exists

    var $stickyrStopper = $('.downloadapp_section');
    var header_height = $('.header-wrapper').innerHeight();
    var header_search = $( '.header__search--in-header.large-up-hide' ).innerHeight();

    var generalSidebarHeight = $sticky.innerHeight();
    var stickyTop = $sticky.offset().top;
    var stickOffset = header_height + 20 + header_search;

    var stickyStopperPosition = $stickyrStopper.offset().top;
    var stopPoint = stickyStopperPosition - generalSidebarHeight - stickOffset;
    var diff = stopPoint + stickOffset;

    $(window).scroll(function(){ // scroll event
        var windowTop = $(window).scrollTop(); // returns number

        if (stopPoint < windowTop) {
            var elementHeight = $('.downloadapp_section').outerHeight(true);
            $sticky.css('margin-bottom', elementHeight);
            $sticky.css({ position: 'sticky',bottom: 0 });
        } else if (stickyTop < windowTop+stickOffset) {
            $sticky.css({ position: 'sticky', top: stickOffset });
        } else {
            $sticky.css({position: 'unset' });
        }
    });
}







//////////////////////////////////////////////////////////////////////////////////////////
// buy now button
//////////////////////////////////////////////////////////////////////////////////////////

function StartupBuyNowButton( )
{
    
    var buyNowButton = document.querySelector( ".pdp-buy-now" );
    var atcButton;

    function FindATCButton( )
    {
        var atcButtons = document.querySelectorAll( "form .product-form__submit" );
        for ( var i = 0; i < atcButtons.length; i++ )
        {
            if ( atcButtons[ i ].clientHeight > 0 )
            {
                atcButton = atcButtons[ i ];
                break;
            }
        }
    }
    
    function SetBuyNowVisibility( )
    {
        var atcBCR = atcButton.getBoundingClientRect( );

        if ( ( atcBCR.top < 100 ) )
        {
          buyNowButton.classList.remove( "hidden" );
        }
        else
        {
            buyNowButton.classList.add( "hidden" );
        }
    }

    buyNowButton.addEventListener( "click", function( e )
    {
        atcButton.scrollIntoView( { "behavior" : "smooth", "block" : "end" } );
    } );
    
    FindATCButton( );
    window.addEventListener( "resize", FindATCButton );

    document.addEventListener( "scroll", function( e )
    {
        SetBuyNowVisibility( );
    } );
    SetBuyNowVisibility( );
}

if ( document.querySelector("body").classList.contains("product") ) {
  if ( document.querySelector( ".pdp-buy-now" ) )
  {
    StartupBuyNowButton( );
  }
  else
  {
      window.addEventListener( "load", StartupBuyNowButton );
    }
}

